module.exports = __webpack_public_path__ + "images/8d8e61384951d2e56c8c32056af6e162.svg";